import api from "./api";

export function extractCollection(response, responseKey) {
  const collection = response && response.data && response.data[responseKey];
  return Array.isArray(collection) ? collection : [];
}

export function normalizeApiError(error) {
  const response = error && error.response;
  const messages = response && response.data && response.data.messages;
  return {
    status: response ? response.status : 0,
    message:
      (messages && (messages.databaseError || messages.authError)) ||
      (error && error.message) ||
      "Request failed",
    response,
  };
}

export async function getCollection(endpoint, responseKey, options = {}) {
  try {
    const response = await api.get(endpoint, { signal: options.signal });
    return extractCollection(response, responseKey);
  } catch (error) {
    if (error && (error.name === "CanceledError" || error.code === "ERR_CANCELED")) {
      return [];
    }
    if (options.onError) options.onError(normalizeApiError(error));
    return [];
  }
}
